import AbstractRosterShift from './AbstractRosterShift';

export default class NoRoster extends AbstractRosterShift {
  constructor(start, end) {
    super('noroster', start, end, true);
  }

  createNew(start, end, hasActuals) {
    return new NoRoster(start, end, true);
  }
}
